/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AddPluginServerForm,
  AddPluginServerForm$Outbound,
  AddPluginServerForm$outboundSchema,
} from "../components/addpluginserverform.js";

export type AddPluginServerSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AddPluginServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  addPluginServerForm: AddPluginServerForm;
};

/** @internal */
export type AddPluginServerSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AddPluginServerSecurity$outboundSchema: z.ZodMiniType<
  AddPluginServerSecurity$Outbound,
  AddPluginServerSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function addPluginServerSecurityToJSON(
  addPluginServerSecurity: AddPluginServerSecurity,
): string {
  return JSON.stringify(
    AddPluginServerSecurity$outboundSchema.parse(addPluginServerSecurity),
  );
}

/** @internal */
export type AddPluginServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AddPluginServerForm: AddPluginServerForm$Outbound;
};

/** @internal */
export const AddPluginServerRequest$outboundSchema: z.ZodMiniType<
  AddPluginServerRequest$Outbound,
  AddPluginServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    addPluginServerForm: AddPluginServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      addPluginServerForm: "AddPluginServerForm",
    });
  }),
);

export function addPluginServerRequestToJSON(
  addPluginServerRequest: AddPluginServerRequest,
): string {
  return JSON.stringify(
    AddPluginServerRequest$outboundSchema.parse(addPluginServerRequest),
  );
}
